import Button from "devextreme-react/button";
import { useState } from "react";
import { FileTypes, KindOfOrder } from "../../../../types/enums";
import { FileAttachment } from "../types/FileAttachment";
import './FileAttachmentsButton.scss'
import FileAttachmentsPopup from "./FileAttachmentsPopup";

export default function FileAttachmentsButton(props:
	{
		attachedFiles: FileAttachment[]
		orderID?: number,
		parentGuid: string,
		kindOfOrder: KindOfOrder,
		orderTypeID?: number,
		defaultFileType?: FileTypes,
		fileTypeFilter?: (fileType: FileTypes) => boolean,
		useFileTypes: boolean,
		hideDeleteButton?: boolean,
		replaceFile?: boolean,
		onFileAdded: () => void,
		onFileDeleted: () => void
	}) {
	const [isPopupVisible, setPopupVisibility] = useState(false);

	return (
		<>
			<Button
				text="File Attachments"
				icon="Inscyth-File-Attachments"
				elementAttr={{ 'data-testid': 'btn-file-attachments' }}
				disabled={isPopupVisible}
				onClick={() => setPopupVisibility(true)}
			>
			</Button>

			<FileAttachmentsPopup
				attachedFiles={props.attachedFiles}
				orderID={props.orderID}
				parentGuid={props.parentGuid}
				kindOfOrder={props.kindOfOrder}
				orderTypeID={props.orderTypeID}
				defaultFileType={props.defaultFileType}
				fileTypeFilter={props.fileTypeFilter}
				useFileTypes={props.useFileTypes}
				visible={isPopupVisible}
				hideDeleteButton={props.hideDeleteButton}
				replaceFile={props.replaceFile}
				onFileAdded={props.onFileAdded}
				onFileDeleted={props.onFileDeleted}
				onPopupHidden={() => setPopupVisibility(false)}
			/>
		</>
	)
}
